<template>
  <div class="video">
<!--    <div>-->
<!--      <otherNav></otherNav>-->
<!--    </div>-->
    <breadcrumb class="bread" :path="path" :name="name" :childPath="childPath" :childName="childName"></breadcrumb>
   <section class="section-main">
     <div class="section-middle">
       <div class="section-video">
         <ul class="video-ul">
<!--           <li v-for="item in videoList" :key="item.id" class="video-ul-li">-->
<!--             <div>{{item.pictureVideoFileList}}</div>-->
<!--             <div>{{item.title}}</div>-->
<!--             <div>{{item.videoCoverList}}</div>-->
<!--           </li>-->
           <li class="video-ul-li"v-for="item in videoList" :key="item.id" >
             <div class="video-ul-li-videoPlay" v-for="video in item.pictureVideoFileList" :key="video.id">
<!--               {{video.url}}-->
               <video-player
                   :poster="posterPic"
                   class="video-player vjs-custom-skin"
                   :playsinline="true"
                   style="object-fit:cover;height: 100%!important;"
                   :options="`/admin/sys-file/getFileInfo${video.url}` | videoOption">
               </video-player>
             </div>
             <div class="video-ul-li-title">{{ item.title }}</div>
           </li>
         </ul>
       </div>
       <div class="clear"></div>
       <el-pagination
           :page-size="pageSize"
           :current-page.sync="page"
           layout="total,prev, pager, next"
           @size-change="handleSizeChange"
           @current-change="handleCurrentChange"
           :total="totalPage">
       </el-pagination>
     </div>
   </section>
  </div>
</template>

<script>
import otherNav from '@/components/navBar/otherNav'
import breadcrumb from '@/components/breadcrumb/index'
import { fetchList } from '@/network/scientificRearch/video'
export default {
  name: "video",
  components: { breadcrumb, otherNav },
  filters:{
    videoOption(val) {
      // console.log('val',val)
      return {
        playbackRates: [0.5,1.0,1.5,2.0],
        live: false,
        preload: "auto",
        autoplay: false,
        language: "zh-CN",
        aspectRatio: "16:9",
        fluid: true,
        sources: [
          {
            src: val //url地址
          }
        ],
        hls: true,
        notSupportedMessage: "此视频暂无法播放，请稍后再试", //允许覆盖Video.js无法播放媒体源时显示的默认信息。
        controlBar: {
          timeDivider: true, //当前时间和持续时间的分隔符
          durationDisplay: true, //显示持续时间
          remainingTimeDisplay: false, //是否显示剩余时间
          fullscreenToggle: true //全屏按钮

        },
        flash: {
          hls: {
            withCredentials: false
          }
        }
      }
    },
  },
  data() {
    return {
      num: 0,
      path: '',
      name: '',
      childName:'',
      childPath:'',
      videoList: [],
      page: 1,
      pageSize: 7,
      totalPage: 0,
      type: 'video',
      videoActive: 0,
      activeVideo: '',
      imgSrc: '',
      canvasUrl: [],
      coverPic: '',
      posterPic:"",
      posterPicList: [],
      isControls: true,
      videoBlob: []
    }
  },
  beforeRouteEnter (to, from, next) {
    next(vm => {
      vm.path = from.path
      vm.name = '科考影像'
    })
  },
  mounted() {
   this.getList()

  },

  created() {
    this.childName = '视频'
    this.childPath = this.$route.path
  },

  methods: {
    handleSizeChange(val) {
      this.pageSize = val
      this.page = 1
      this.getList()
    },
    handleCurrentChange(val) {
      this.page = val
      this.getList()
    },
    getVideoTime(event) {
      const video = document.getElementById('video')
      // console.log('rwrw',event)
    },

    getList() {
      fetchList(Object.assign({
        current: this.page,
        size: this.pageSize,
        type: this.type
      })).then(response => {
        // console.log(response)
        this.videoList = response.data.data.records
        this.totalPage = response.data.data.total
        this.videoList.map((item,index) => {
          item.pictureVideoFileList.map(e => {
            // console.log(e)
            // e.setContentLength((init))
            this.canvasUrl.push(e.url)
            return this.canvasUrl
          })
          item.videoCoverList.map(i => {
            this.posterPicList.push(i.url)
            return this.posterPicList
          })
          return  this.videoBlob
        })
        // console.log('55',this.videoList)

      })
    },
    getLi() {
      if (this.videoActive = 0) {
        this.activeVideo = 'activeVideo'
      }
    },
    handleSelect(key, keyPath) {
      this.$router.push({path: key}).catch(err => {
        // console.log(err)
      })
    },
    createPreImg(event) {
      const videoEle = event.target
      // videoEle.currentTime = 1
      // videoEle.addEventListener('canplay', function () {
      //   console.log(this.coverPic)
        // const canvas = document.createElement('canvas')
        // const scale = 0.1
        // canvas.width = videoEle.videoWidth * scale;
        // canvas.height = videoEle.videoHeight * scale;
        // canvas.getContext('2d').drawImage(videoEle, 0, 0, canvas.width, canvas.height);

        // 把canvas转成base64编码格式
        // const imgSrc = canvas.toDataURL('image/png');
        // this.imgsrc =  imgSrc.replace(/[\r\n]/g, '')
        // console.log('123',this.imgSrc)
        // 创建img元素 插入到文档中
        const img = document.createElement('img');
        // img.src = imgSrc;
        img.src = this.coverPic;
        img.style.position = 'absolute';
        img.style.left = '0';
        img.style.top = '0';
        img.style.bottom = '0'
        img.style.width = '100%';
        img.style.height = '100%';
        img.style.zIndex = '-1';
        img.style.objectFit = 'cover';
        videoEle.parentNode && videoEle.parentNode.appendChild(img);
      // })
    },

    //查看详情
    toDetail(id, type) {
      // console.log(id, type)
      this.$router.push('/detail/' + id + '/' + type)
    },
  }
}
</script>

<style scoped lang="scss">
@import "../../assets/css/video";
.box {
  width: 600px ; height: 350px;background-color: #000;margin-left: 20px;margin-top: 50px;
  margin-bottom: 10px;
}
::v-deep .el-pagination {
  //padding: 20px 5px !important;
  text-align: center;
}
::v-deep .vjs-custom-skin > .video-js .vjs-control {
  width: 2.5em !important;
  right: 5px;
}
::v-deep .vjs-custom-skin > .video-js .vjs-play-progress::before {
  top: -0.25em !important;
}
@media screen and (max-width: 1200px) {}
@media screen and (max-width: 992px) {}
@media screen and (max-width: 768px) {}
@media screen and (max-width: 576px) {}
@media screen and (max-width: 375px) {}


</style>